<template>
  <div class="bg-gray-50 flex flex-col justify-center py-8 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-xl">
      <div class="bg-white py-6 px-4 shadow-xl sm:rounded-lg sm:px-8">
        <div>
          <h2 class="text-center auth-title">
            Nouveau mot de passe
          </h2>
          <p class="mt-2 text-center auth-subtitle">
            Choisissez votre nouveau mot de passe
          </p>
        </div>

        <form class="mt-8 space-y-6" @submit.prevent="handleSubmit">
          <div class="rounded-md shadow-sm -space-y-px">
            <div>
              <label for="password" class="sr-only">Nouveau mot de passe</label>
              <input
                id="password"
                v-model="password"
                type="password"
                required
                class="appearance-none rounded-t-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Nouveau mot de passe"
              />
            </div>
            <div>
              <label for="confirmPassword" class="sr-only">Confirmer le mot de passe</label>
              <input
                id="confirmPassword"
                v-model="confirmPassword"
                type="password"
                required
                class="appearance-none rounded-b-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Confirmer le mot de passe"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              :disabled="loading || !isValid"
              class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              <span v-if="loading">Modification en cours...</span>
              <span v-else>Modifier le mot de passe</span>
            </button>
          </div>

          <div v-if="message" class="mt-2 text-sm text-center"
               :class="{'text-green-600': !error, 'text-red-600': error}">
            {{ message }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const message = ref('')
const error = ref(false)

const isValid = computed(() => {
  return password.value.length >= 6 && password.value === confirmPassword.value
})

const handleSubmit = async () => {
  if (!isValid.value) {
    message.value = 'Les mots de passe ne correspondent pas ou sont trop courts'
    error.value = true
    return
  }

  loading.value = true
  message.value = ''
  error.value = false

  try {
    await authStore.resetPassword(route.params.token, password.value)
    message.value = 'Mot de passe modifié avec succès'
    error.value = false
    setTimeout(() => {
      router.push('/login')
    }, 2000)
  } catch (err) {
    message.value = err.response?.data?.message || 'Une erreur est survenue'
    error.value = true
  } finally {
    loading.value = false
  }
}
</script> 